import React, { useState } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Button, notification, Space, Dropdown } from "antd";
import {
  FileExcelOutlined,
  FileTextOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import normalizarCoordenada from "../../../utils/normalizarGeoreferencias";

const ExportVisitasTecnicasSostenibilidad = ({ dataCompleta }) => {
  const [loading, setLoading] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [loadingJson, setLoadingJson] = useState(false);
  const [optionsVisible, setOptionsVisible] = useState(false);

  const exportToExcel = async () => {
    try {
      if (dataCompleta.length === 0) {
        notification.warning({
          message: "Advertencia",
          description: "No hay datos disponibles para exportar.",
          duration: 3,
        });
        return;
      }
      setLoadingExcel(true);
      const workbook = new ExcelJS.Workbook();
      const templateResponse = await fetch(
        "/assets/plantilla_visitas_tecnicas_sostenibilidad.xlsx"
      );
      const templateBuffer = await templateResponse.arrayBuffer();
      await workbook.xlsx.load(templateBuffer);
      const worksheet = workbook.getWorksheet(1);
      let currentRow = 3;
      dataCompleta.forEach((item) => {
        const startRow = currentRow; // Fila de inicio para esta entrada
        let maxRow = currentRow; // Variable para rastrear la fila más baja ocupada
        worksheet.getCell(`A${startRow}`).value = item.codigo_interno || "";

        const lista_factores = item.lista_factores || [];
        if (lista_factores.length > 0) {
          currentRow = startRow; // Fila de inicio para esta entrada
          lista_factores.forEach((factor) => {
            if (factor && typeof factor === "object") {
              worksheet.getCell(`B${currentRow}`).value = factor.factor || "";
              worksheet.getCell(`C${currentRow}`).value =
                factor.actividad || "";
              worksheet.getCell(`D${currentRow}`).value =
                factor.subActividad || "";
            }
            currentRow++; // Avanzar fila
          });
          maxRow = Math.max(maxRow, currentRow);
        }

        worksheet.getCell(`E${startRow}`).value = item.fecha_registro || "";
        worksheet.getCell(`F${startRow}`).value = item.numero_visita || "";
        worksheet.getCell(`G${startRow}`).value = item.grupoTerritorial || "";
        worksheet.getCell(`H${startRow}`).value = item.departamento || "";
        worksheet.getCell(`I${startRow}`).value = item.municipio || "";
        worksheet.getCell(`J${startRow}`).value = item.vereda || "";
        worksheet.getCell(`K${startRow}`).value = item.codigoPREPP || "";
        worksheet.getCell(`L${startRow}`).value = item.nombreProyecto || "";
        worksheet.getCell(`M${startRow}`).value =
          item.quien_resibe_visita || "";
                worksheet.getCell(`N${startRow}`).value =
          item.nombre_titular_proyecto || "";
                          worksheet.getCell(`O${startRow}`).value =
          item.identificacion_titular_proyecto || "";
                          worksheet.getCell(`P${startRow}`).value =
          item.codigo_titular_proyecto || "";
          

        worksheet.getCell(`Q${startRow}`).value = item.horaInicio || "";
        worksheet.getCell(`R${startRow}`).value = item.horaFin || "";
        worksheet.getCell(`S${startRow}`).value = item.modalidad_sesion_capacitacion || "";
        worksheet.getCell(`T${startRow}`).value = item.numeroHombres || "";
        worksheet.getCell(`U${startRow}`).value = item.numeroMujeres || "";


        worksheet.getCell(`V${startRow}`).value =
          normalizarCoordenada(item.latuser) ?? "";
        worksheet.getCell(`W${startRow}`).value =
          normalizarCoordenada(item.lnguser) ?? "";
        worksheet.getCell(`X${startRow}`).value = item.linea_productiva || "";

        //AVANCE DE ACTIVIDADES POR FACTORES DE SOSTENIBILIDAD
        worksheet.getCell(`Y${startRow}`).value = item.avanceFactor1 || "";
        worksheet.getCell(`Z${startRow}`).value = item.avanceFactor2 || "";
        worksheet.getCell(`AA${startRow}`).value = item.avanceFactor3 || "";
        worksheet.getCell(`AB${startRow}`).value = item.avanceFactor4 || "";
        worksheet.getCell(`AC${startRow}`).value = item.avanceFactor5 || "";
        worksheet.getCell(`AD${startRow}`).value = item.avanceFactor6 || "";
        worksheet.getCell(`AE${startRow}`).value = item.avanceFactor7 || "";
        worksheet.getCell(`AF${startRow}`).value = item.avanceFactor8 || "";
        worksheet.getCell(`AG${startRow}`).value = item.proximaSesion || "";


              const lista_entregables = item.entregables || [];
        if (lista_entregables.length > 0) {
          currentRow = startRow; // Fila de inicio para esta entrada
          lista_entregables.forEach((entregable) => {
            if (entregable && typeof entregable === "object") {
              worksheet.getCell(`AH${currentRow}`).value =
                entregable.nombre_entregable || "";
              worksheet.getCell(`AI${currentRow}`).value =
                entregable.fecha_entregable || "";
            }
            currentRow++; // Avanzar fila solo si hay comercialización
          });
          maxRow = Math.max(maxRow, currentRow);
        }


        worksheet.getCell(`AJ${startRow}`).value = item.hallazgos || "";
        worksheet.getCell(`AK${startRow}`).value = item.recomendaciones || "";

        //ACUERDOS

        const lista_acuerdos = item.acuerdos || [];
        if (lista_acuerdos.length > 0) {
          currentRow = startRow; // Fila de inicio para esta entrada
          lista_acuerdos.forEach((acuerdo) => {
            if (acuerdo && typeof acuerdo === "object") {
              worksheet.getCell(`AL${currentRow}`).value =
                acuerdo.compromiso || "";
              worksheet.getCell(`AM${currentRow}`).value =
                acuerdo.responsable || "";
              worksheet.getCell(`AN${currentRow}`).value =
                acuerdo.fechaLimite || "";
            }
            currentRow++; // Avanzar fila solo si hay comercialización
          });
          maxRow = Math.max(maxRow, currentRow);
        }

        const participantes = item.participantes || [];
        if (participantes.length > 0) {
          currentRow = startRow; // Fila de inicio para esta entrada
          participantes.forEach((p) => {
            if (p && typeof p === "object") {
              worksheet.getCell(`AO${currentRow}`).value = p.codigo_sirr || "";
              worksheet.getCell(`AP${currentRow}`).value =
                p.nombre_completo || "";
            }
            currentRow++; // Avanzar fila solo si hay comercialización
          });
          maxRow = Math.max(maxRow, currentRow);
        }

        worksheet.getCell(`AQ${startRow}`).value = item.name_responsable || "";
        worksheet.getCell(`AR${startRow}`).value = item.user_email || "";
        worksheet.getCell(`AS${startRow}`).value = item.fuente || "";

        for (let row = startRow; row <= maxRow; row++) {
          worksheet.getCell(`A${row}`).value = item.codigo_interno || "";
        }

        currentRow = maxRow;
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      saveAs(blob, "Informe_VisitasTecnicas_Sostenibilidad.xlsx");
      notification.success({
        message: "Éxito",
        description: "Excel exportado correctamente.",
        duration: 3,
      });
    } catch (error) {
      console.error("Error al generar Excel:", error);
      notification.error({
        message: "Error",
        description: "No se pudo exportar el Excel.",
        duration: 3,
      });
    } finally {
      setLoadingExcel(false);
    }
  };

  const exportToJSON = async () => {
    try {
      if (!dataCompleta || dataCompleta.length === 0) {
        notification.warning({
          message: "Advertencia",
          description: "No hay datos disponibles para exportar.",
          duration: 3,
        });
        return;
      }
      setLoadingJson(true);
      const jsonBlob = new Blob([JSON.stringify(dataCompleta, null, 2)], {
        type: "application/json",
      });
      saveAs(jsonBlob, "Informe_VisitasTecnicas_Sostenibilidad.json");
      notification.success({
        message: "Éxito",
        description: "JSON exportado correctamente.",
        duration: 3,
      });
    } catch (error) {
      console.error("Error al generar JSON:", error);
      notification.error({
        message: "Error",
        description: "No se pudo exportar el JSON.",
        duration: 3,
      });
    } finally {
      setLoadingJson(false);
    }
  };

  const menuItems = [
    {
      key: "excel",
      label: (
        <Button
          type="text"
          icon={<FileExcelOutlined />}
          onClick={exportToExcel}
          loading={loadingExcel}
          disabled={loadingExcel}
        >
          Exportar a Excel
        </Button>
      ),
    },
    {
      key: "json",
      label: (
        <Button
          type="text"
          icon={<FileTextOutlined />}
          onClick={exportToJSON}
          loading={loadingJson}
          disabled={loadingJson}
        >
          Exportar a JSON
        </Button>
      ),
    },
  ];

  return (
    <Space>
      <Dropdown
        menu={{ items: menuItems }}
        placement="bottomLeft"
        trigger={["click"]}
      >
        <Button type="primary" icon={<DownloadOutlined />}>
          Exportar
        </Button>
      </Dropdown>
    </Space>
  );
};

export default ExportVisitasTecnicasSostenibilidad;
